module.exports = __webpack_public_path__ + "img/spoken_read_voice2.6639f50b.svg";